import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { Icon } from "../../../../../components/base";
import DoubleCircleImg from "../../../../../assets/images/icons/double-circle.svg";
import { pluralize } from "../../../../../services";

const useStyles = makeStyles(() => ({
  rightSide: {
    borderRight: `1px solid ${COLORS.darks[0][25]}`,
    paddingBottom: 20,
  },
}));

const NoMeterData = () => (
  <Grid item sm={12}>
    <Typography
      style={{
        marginTop: '16%',
        fontWeight: 700,
        fontSize: 21,
        textAlign: "center",
        verticalAlign: "middle",
        color: COLORS.darks[0][25],
      }}
    >
      N/A
    </Typography>
  </Grid>
);

const title = {
  CENTRAL: "Central meter",
  METER_PER_UNIT: "Meter per unit",
};

const MeterTypes = ({ meters }) => {
  const classes = useStyles();

  const getMeterIcon = (type) => {
    switch (type) {
      case "CENTRAL":
        return (
          <Icon
            src={DoubleCircleImg}
            style={{
              display: "block",
              width: 100,
              height: 100,
              margin: "0 auto",
              marginBottom: 20,
            }}
          />
        );
      case "METER_PER_UNIT":
        return (
          <Grid container style={{ width: 102, margin: "0 auto 20px" }}>
            <Grid item xs={6} style={{ marginBottom: 10 }}>
              <Icon src={DoubleCircleImg} />
            </Grid>
            <Grid item xs={6} style={{ textAlign: "center" }}>
              <Icon src={DoubleCircleImg} />
            </Grid>
            <Grid item xs={6}>
              <Icon src={DoubleCircleImg} />
            </Grid>
            <Grid item xs={6} style={{ textAlign: "center" }}>
              <Icon src={DoubleCircleImg} />
            </Grid>
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <ShaDowBox fullHeight>
        <Box style={{ padding: 24 }}>
          <Typography variant="h4">Meter types</Typography>
          <Grid container style={{ marginTop: 50 }}>
            {meters?.length ? (
              meters.map((meter, index) => {
                return (
                  <Grid
                    key={index}
                    item
                    sm={12 / meters?.length}
                    className={index < meters.length - 1 ? classes.rightSide : null}
                  >
                    {getMeterIcon(meter.meter_type)}
                    <Typography style={{ textAlign: "center", fontSize: 18, marginBottom: 8 }}>
                      {title[meter.meter_type]}
                    </Typography>
                    <Typography variant="h2" style={{ textAlign: "center" }}>
                      {meter.buildings_count}{" "}
                      {pluralize(meter.buildings_count, "building", { withCount: false })}
                    </Typography>
                  </Grid>
                );
              })
            ) : (
              <NoMeterData />
            )}
          </Grid>
        </Box>
      </ShaDowBox>
    </>
  );
};

export default MeterTypes;
